// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ModalHeader = styled.h2`
  padding: var(--mantine-spacing-xl);
`;

export const ModalSubtitle = styled.p`
  padding: 0 var(--mantine-spacing-xl);
`;

export const ModalRadioRoot = styled.div`
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-xl);
`;
